import React from "react";
import * as core from "@material-ui/core";
import { useTranslation } from "react-i18next";


const RegisterClient = (props) => {
  const { t } = useTranslation();
  const {values, handleBlur, handleChange ,registeredBefore} = props;
  return (
     <core.Card>
      <core.CardHeader title="Client Register" />
      <core.Divider />
      <core.CardContent>
  
            <core.FormControlLabel style={{ width: "100%"}} control=
            {
              <core.Switch name="isRegistered" 
                color="primary" 
                disabled ={registeredBefore}
                value={values.isRegistered}
                checked={values.isRegistered} 
                onBlur={handleBlur} 
                onChange={handleChange} />
            }
            label={t("vocationaltag.vocationalswitch")} />
        
      </core.CardContent>
    </core.Card>
  
  );
};

export default RegisterClient;
